import React from 'react'

const BookSvg = ({ width }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} viewBox='0 0 16 20'>
      <g id='book-svgrepo-com' transform='translate(-4 -2)'>
        <path
          id='Path_3199'
          data-name='Path 3199'
          d='M6.271,2.112a2.514,2.514,0,0,0-1.544.6,2.413,2.413,0,0,0-.613,1.513A28.456,28.456,0,0,0,4,7.676v8.569a4.172,4.172,0,0,1,1.3-.592,8.437,8.437,0,0,1,2.047-.138H20V7.676a28.47,28.47,0,0,0-.114-3.451,2.413,2.413,0,0,0-.613-1.513,2.514,2.514,0,0,0-1.544-.6A30.253,30.253,0,0,0,14.207,2H9.793A30.252,30.252,0,0,0,6.271,2.112Zm.488,4.483a.819.819,0,0,1,.828-.811h8.828a.811.811,0,1,1,0,1.622H7.586A.819.819,0,0,1,6.759,6.595Zm.828,2.973a.811.811,0,1,0,0,1.622H13.1a.811.811,0,1,0,0-1.622Z'
          fill='#658f7e'
          fillRule='evenodd'
        />
        <path
          id='Path_3200'
          data-name='Path 3200'
          d='M7.473,17.135H20a21.268,21.268,0,0,1-.113,2.64,2.413,2.413,0,0,1-.613,1.513,2.514,2.514,0,0,1-1.544.6A30.251,30.251,0,0,1,14.207,22H9.793a30.251,30.251,0,0,1-3.522-.111,2.515,2.515,0,0,1-1.544-.6,2.413,2.413,0,0,1-.613-1.513c-.041-.3-.068-.637-.084-1.019a2.464,2.464,0,0,1,1.7-1.538A8,8,0,0,1,7.473,17.135Z'
          fill='#658f7e'
        />
      </g>
    </svg>
  )
}

export default BookSvg
